<template>
  <div class="search__block" ref="inner" :class="{ loading: getLoading }">
    <searchModel :showSearchHints="false" :placeholder="searchPlaceholder"></searchModel>

    <!--скелетная загрузка-->
    <div
      v-if="!contentLoaded || getLoading"
      :class="[gridType === 'small' ? 'grid' : 'grid grid__row']"
    >
      <div
        class="model__item model-card_wrapper model-card_wrapper--skeleton"
        v-for="(item, index) in getModelsCount()"
        :key="index"
      ></div>
    </div>

    <!--вывод карточек  -->
    <div v-else-if="!getLoading" class="grid" :class="{ grid__row: gridType === 'big' }">
      <bim-product-card
        class="model__item"
        v-for="model in models"
        :key="model.id"
        v-bind="model"
        :type="gridType === 'small' ? 'card': 'wide'"
        itemscope
        itemtype="http://schema.org/ImageObject"
        width="100%"
      />
    </div>

    <!--ничего не найдено-->
    <div
      v-if="!models.length && !getLoading && requested"
      class="col-xxl-10 col-12 d-flex flex-column align-center mx-auto py-md-12 not-found pt-0"
    >
      <p class="notfound-title mb-md-9 mb-6">{{$t('Подходящих моделей не найдено')}}</p>
      <p class="notfound-subtitle mb-9">Попробуйте поиск без фильтров</p>
      <bim-button width="200" color="gray" @click="resetFilter()" label="Очистить фильтры" size="l"></bim-button>
    </div>

    <bim-pagination
      class="models__pagination"
      :totalPages="totalPages"
      :activePage="activePage"
      @changePage="whatPage"
    />
  </div>
</template>

<script>
  import searchModel from '@/pages/models/SearchModels.vue'
  import bimProductCard from '@bimlib/components/bimProductCard'
  import bimButton from '@bimlib/components/bimButton'
  import bimPagination from '@bimlib/components/bimPagination'
  import bimRow from '@bimlib/components/bimRow'
  import bimCol from '@bimlib/components/bimCol'
  import FormModelCardDataMixin from '@/mixins/models/form-model-card-data'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'SearchBlock',
    mixins: [FormModelCardDataMixin],
    components: {
      searchModel,
      bimPagination,
      bimProductCard,
      bimButton,
      bimRow,
      bimCol
    },
    props: {
      searchPlaceholder: String,
      attributeNumber: Number
    },
    data () {
      return {
        activePage: 1,
        requested: false
      }
    },
    created() {
      this.setPageFromURL();
    },
    async mounted () {
      await this.$store.commit('countFilteres', this.getModelsCount())
      await this.$store.commit('attributesFilteres', this.attributeNumber)
      await this.$store.dispatch('locationQueryOnLoad')

      setTimeout(() => {
        this.requested = true
      }, 2000)
    },
    computed: {
      ...mapGetters([
        'totalPages',
        'gridType',
        'modelsData',
        'contentLoaded',
        'getLoading'
      ]),
      models () {
        return this.modelsData.map(data => this.formModelData(data, (this.gridType === 'small' ? 'card': 'wide')))
      }
    },
    methods: {
      setPageFromURL() {
        const url = window.location.href
        const page = /page=(\d+)/.exec(url)

        if (page) {
          this.activePage = parseInt(page[1])
          this.$store.dispatch('setPage', this.activePage)
        }
      },
      getModelsCount () {
        const width = window.innerWidth
        let count = 7
        let rows = 7

        if (width <= 320) {
          count = 2
          rows = 5
        } else if (width <= 576) {
          count = 3
          rows = 6
        } else if (width <= 768) {
          count = 4
          rows = 6
        } else if (width <= 960) {
          count = 5
        } else if (width <= 1278) {
          count = 6
        }

        return count * rows
      },
      ...mapActions([
        'resetFilter',
      ]),
      async whatPage (page) {
        this.activePage = page
        await this.$store.dispatch('setPage', this.activePage)
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import "./src/front_white/sass/components/settings";

  .search__block {
    max-width: 1161px;
    margin: 0 auto;
    position: relative;
  }

  .search__block.loading {
    pointer-events: none;
    opacity: 0.5;
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-gap: 8px;
    @media all and (max-width: $breakpoint-xl) {
      grid-template-columns: repeat(6, 1fr);
    }
    @media all and (max-width: $breakpoint-lg) {
      grid-template-columns: repeat(5, 1fr);
    }
    @media all and (max-width: $breakpoint-md) {
      grid-template-columns: repeat(4, 1fr);
    }
    @media all and (max-width: $breakpoint-sm) {
      grid-template-columns: repeat(3, 1fr);
    }
    @media all and (max-width: 400px) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .grid.grid__row {
    display: block;

    .model__item + .model__item {
      margin-top: 14px;
    }
  }

  .models__pagination {
    padding-top: 40px;
    padding-bottom: 100px;
  }

  .notfound-title {
    font-size   : 32px;
    font-weight : bold;
  }

  .notfound-subtitle {
    font-size : 18px;
  }

  .model__item.model-card_wrapper {
    height: 232px;
  }

  @media all and (max-width: $breakpoint-lg) {
    .models__pagination {
      padding-top: 24px;
      padding-bottom: 64px;
    }
  }

  @media all and (max-width: $breakpoint-sm) {
    .models__pagination {
      padding-top: 14px;
      padding-bottom: 34px;
    }
  }
</style>
